<template>
  <AeModal v-model="showModal" :title="t('invitationsBanner.title')">
    <div class="invitations-banner">
      <p>{{ invitations.length === 1 ? t('invitationsBanner.pendingSingular') : t('invitationsBanner.pendingPlural', { n: invitations.length }) }}</p>
      <div class="invitations-list">
        <div v-for="inv in invitations" :key="inv.id_invitation" class="invitation-item">
          <div class="invitation-info">
            <strong>{{ inv.target_name }}</strong>
            <span class="invitation-type">
              {{ inv.invitation_type === 'team' ? t('invitationsBanner.typeTeam') : t('invitationsBanner.typeOrg') }}
            </span>
            <span v-if="inv.inviter_name" class="invitation-from">{{ t('invitationsBanner.invitedBy', { name: inv.inviter_name }) }}</span>
          </div>
          <div class="invitation-actions">
            <AeButton size="small" @click="openInvitation(inv)">{{ t('invitationsBanner.accept') }}</AeButton>
            <AeButton size="small" variant="outline" @click="reject(inv.id_invitation)">{{ t('invitationsBanner.reject') }}</AeButton>
          </div>
        </div>
      </div>
    </div>
  </AeModal>

  <!-- Gestisce accettazione (incluso l'avviso "nuovo profilo" per inviti org) -->
  <InvitationModal
    :invitation="selectedInvitation"
    @close="selectedInvitation = null"
    @done="handleInvitationDone"
  />
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useOrgStore } from '../stores/orgStore'
import { useAppStore } from '../stores/app'
import { AeButton, AeModal } from '@aevue/components'
import InvitationModal from './InvitationModal.vue'

const { t } = useI18n()
const orgStore = useOrgStore()
const appStore = useAppStore()
const showModal = ref(false)
const invitations = ref([])
const selectedInvitation = ref(null)

async function checkInvitations() {
  if (!appStore.isAuthenticated) return
  const result = await orgStore.fetchPendingInvitations()
  if (result?.ok && orgStore.pendingInvitations.length > 0) {
    invitations.value = orgStore.pendingInvitations
    showModal.value = true
  }
}

function openInvitation(inv) {
  showModal.value = false
  selectedInvitation.value = inv
}

function handleInvitationDone({ newProfile }) {
  invitations.value = invitations.value.filter(i => i.id_invitation !== selectedInvitation.value?.id_invitation)
  selectedInvitation.value = null
  if (newProfile) {
    alert(t('invitationsBanner.newProfileCreated'))
  } else if (invitations.value.length === 0) {
    window.location.reload()
  } else {
    showModal.value = true
  }
}

async function reject(id) {
  const result = await orgStore.rejectInvitation(id)
  if (result.ok) {
    invitations.value = invitations.value.filter(i => i.id_invitation !== id)
    if (invitations.value.length === 0) {
      showModal.value = false
    }
  }
}

// Check inviti quando l'utente si autentica
watch(() => appStore.isAuthenticated, (isAuth) => {
  if (isAuth) {
    checkInvitations()
  }
})

onMounted(() => {
  if (appStore.isAuthenticated) {
    checkInvitations()
  }
})
</script>

<style scoped>
.invitations-banner p {
  margin-bottom: 1rem;
}

.invitations-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.invitation-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background: var(--ae-bg-secondary, #f5f5f5);
  border-radius: 6px;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.invitation-info {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.invitation-type {
  font-size: 0.85rem;
  color: var(--ae-text-secondary, #666);
}

.invitation-from {
  font-size: 0.8rem;
  color: var(--ae-text-secondary, #888);
}

.invitation-actions {
  display: flex;
  gap: 0.5rem;
}
</style>
